<template>
  <b-modal
    id="modal-comments"
    ref="my-modal"
    title="Comentarios"
    ok-title="Vale"
    @ok="handleOk"
    size="lg"
    ok-only
  >
    <div class="container-comments">
      <app-timeline>
        <app-timeline-item
          v-for="(comment, index) in commentsWithComments" :key="index"
          variant="primary"
          class="border-bottom"
        >
          <div
            class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
          >
            <h6 class="mb-0">{{ comment.comentario }}</h6>
            <div class="mr-4">
              <small class="text-muted">{{ comment.fecha | dateFormatTime }}</small>
              <feather-icon
                v-has-permission="'ED271'"
                data-cy="delete-comment"
                v-if="canDeleteComment(comment)"
                class="ml-2 text-danger cursor-pointer"
                icon="Trash2Icon"
                v-tooltip="'Eliminar comentario'"
                @click="remover(comment)"
              />
            </div>
          </div>
          <p class="mb-2">
            {{ comment.nombre }}
          </p>
          <div class="">
            <div class="mb-1 mb-sm-0" v-if="comment.documentos">
              <div v-for="(attachment, index) in comment.documentos" :key="index" class="d-flex mb-1 color-primary">
                <DownloadFile
                  :mood="'compact'"
                  :path="attachment.adjuntoUrl"
                  :name="attachment.nombre"
                  :version-id="attachment.versionId"
                  class="pill-info-attach mr-1"
                  v-tooltip.bottom-end="`${attachment.nombre}`"
                />
                {{attachment.nombre}}
                <feather-icon
                  v-has-permission="'ED272'"
                  data-cy="delete-attachment"
                  v-if="canDeleteComment(comment)"
                  class="ml-2 text-danger cursor-pointer"
                  icon="Trash2Icon"
                  v-tooltip="'Eliminar adjunto'"
                  @click="removerAdjunto(attachment)"
                />
              </div>
            </div>
          </div>
        </app-timeline-item>
      </app-timeline>
    </div>
  </b-modal>
</template>
<script>

import { BModal, VBModal } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { mapActions, mapGetters } from 'vuex';

import DownloadFile from '@/febos/chile/dnt/components/DownloadFile';
import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import FileStates from '@/febos/chile/approvals/mixins/FileStates';
import { deleteCommentFlow, deleteCommentAttachmentFlow } from '@/febos/servicios/api/aprobaciones.api';

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BModal,
    DownloadFile
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      commentary: ''
    };
  },
  computed: {
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Approvals', [
      'fileOnFlow',
      'fileOnFlowAttachments',
    ]),
    currentStep() {
      const {
        detalle: {
          pasos = [],
          ejecucion
        } = {}
      } = this.fileOnFlow;
      return pasos
        .find((step) => (
          step.id === ejecucion.pasoActualId
        ));
    },
    commentsWithComments() {
      return this.comments;
    },
  },
  props: {
    comments: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalFileDetails',
      'getAttachmentFiles',
      'getApprovalsTemplates',
      'getStepTypes',
      'getStepRoles'
    ]),
    handleOk() {
      this.$nextTick(() => {
        this.$refs['my-modal'].hide();
      });
    },
    canDeleteComment(comment) {
      const stepIdFlow = this.fileOnFlow?.detalle?.ejecucion?.pasoActualId;
      const estado = this.fileOnFlow?.detalle?.ejecucion?.aprobacionesEjecucionEstadoId;
      return this.currentStep.id === stepIdFlow && comment.aprobacionesPasoEjecucionId === this.currentStep.id
        && comment.usuarioId === this.currentUserId && estado === FileStates.INITIATED;
    },
    remover(comment) {
      const { fileId } = this.$route.params;
      const { flowId } = this.$route.params;
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Heey!',
        text: '¿Estas seguro de eliminar este comentario?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          const response = await deleteCommentFlow({
            idEjecucion: flowId,
            idAprobacion: fileId,
            pasoId: this.currentStep.id,
            comentarioId: comment.id
          });
          console.log('response', response);
          await Promise.all([
            this.getApprovalFileDetails({
              aprobacionId: fileId,
              ejecucionId: flowId,
              retornarPdf: 'no'
            }),
            this.getAttachmentFiles({
              aprobacionId: fileId,
              ejecucionId: flowId
            })
          ]);
          this.$refs['my-modal'].hide();
          await this.$bvToast.toast(
            'Vale, se ha eliminado el comentario',
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 4000
            }
          );
        },
        cancel: () => {
          this.$refs['my-modal'].hide();
        }
      });
    },
    removerAdjunto(attachment) {
      const { fileId } = this.$route.params;
      const { flowId } = this.$route.params;
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Heey!',
        text: '¿Estas seguro de eliminar este adjunto?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          const response = await deleteCommentAttachmentFlow({
            idEjecucion: flowId,
            idAprobacion: fileId,
            adjuntoId: attachment.id,
            comentarioId: attachment.aprobacionesComentarioId
          });
          await Promise.all([
            this.getApprovalFileDetails({
              aprobacionId: fileId,
              ejecucionId: flowId,
              retornarPdf: 'no'
            }),
            this.getAttachmentFiles({
              aprobacionId: fileId,
              ejecucionId: flowId
            })
          ]);
          this.$refs['my-modal'].hide();
          await this.$bvToast.toast(
            'Vale, se ha eliminado el adjunto',
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 4000
            }
          );
        },
        cancel: () => {
          this.$refs['my-modal'].hide();
        }
      });
    }
  }
};
</script>
<style>
.container-comments {
  height: 350px;
  overflow-y: scroll;
}

</style>
